<template>
    <div id="app" class="my-0 py-0">
        <v-app id="inspire">
            <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                <v-card v-model="show" class="py-0">
                    <v-toolbar class="py-0 my-0" dark color="green">
                        <v-toolbar-title class="my-0 py-0">Bienes alquilados a cobrar</v-toolbar-title>

                    </v-toolbar>
                </v-card>
                <v-card color="green lighten-4" class="py-0 my-0">
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="6" sm="3" md="2">
                                <v-select v-model="mes" item-color="green" color="green darken-2" dense
                                    :items="listadomeses" label="Mes" item-text="detalle"
                                    item-value="codigo"></v-select>
                            </v-col>
                            <v-col cols="6" sm="3" md="1">
                                <v-text-field dense v-model="anio" label="Año"></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="6" md="4" align-self="stretch" class="d-flex justfy-center">
                                <v-radio-group v-model="tipo" row dense>
                                    <v-radio label="Todos" value="T"></v-radio>
                                    <v-radio label="Por Depósito" value="D"></v-radio>
                                </v-radio-group>
                            </v-col>
                            <v-col cols="6" sm="6" md="3" align-self="stretch">
                                <v-select v-if="tipo == 'D'" v-model="deposito" item-color="green"
                                    color="green darken-2" dense :items="listadodeposito" label="Depósito"
                                    item-text="detalle" item-value="codigo"></v-select>
                            </v-col>

                        </v-row>
                        <v-row dense>
                            <v-col ols="6" sm="3" md="2" align-self="stretch">
                                <v-btn color="success" @click.stop="cargarAlquiler">Mostrar</v-btn>
                            </v-col>
                            <v-col ols="6" sm="3" md="2" align-self="stretch">
                                <v-btn color="success" @click.stop="imprimirAlquiler"
                                    :disabled="botonimprimir">Imprimir</v-btn>
                            </v-col>
                            <v-col ols="6" sm="3" md="2" align-self="stretch">
                                <v-btn color="success" @click.stop="enviarAviso" :disabled="botonenviar">Enviar
                                    Aviso</v-btn>
                            </v-col>
                        </v-row>

                    </v-card-text>
                </v-card>
                <v-card>
                    <v-data-table dense :headers="headers" :items="bienesalquilados" locale="es-ar" class="elevation-1"
                        :items-per-page="500" hide-default-footer>
                        <template v-slot:item.actions="{ item }">
                            <v-icon small color="blue" @click="cargarAlquilerDeposito(item.codigo, item.detalle, '1')">
                                mdi-eye
                            </v-icon>
                        </template>
                        <template slot="body.append">
                            <tr>
                                <th>-</th>
                                <th>TOTAL</th>
                                <th>{{ total }}</th>
                            </tr>
                        </template>
                    </v-data-table>

                </v-card>
                <v-card>
                    <v-card-text>
                        <h6 style="color:darkgreen">Detalle: {{ detalledeposito }}</h6>
                    </v-card-text>
                    <v-data-table dense :headers="headersC" :items="bienesalquiladosdeposito" locale="es-ar"
                        class="elevation-1" :items-per-page="100" hide-default-footer>
                        <template v-slot:item.actions="{ item }">
                            <v-icon small color="blue" @click="deleteItem(item)">
                                mdi-eye
                            </v-icon>
                        </template>
                        <template v-slot:item.remito="{ item }">
                            <v-chip @click="ver(item)">
                                {{ item.remito }}
                            </v-chip>
                        </template>
                        <template slot="body.append">
                            <tr>
                                <th>-</th>
                                <th>TOTAL</th>
                                <th>-</th>
                                <th>-</th>
                                <th>-</th>
                                <th>-</th>
                                <th>-</th>
                                <th>{{ totalD }}</th>
                            </tr>
                        </template>
                    </v-data-table>

                </v-card>
                <Ver :visible="showVer" :remito="editedItem.remito" @close="showVer = false">
                </Ver>
            </v-form>
        </v-app>
    </div>
</template>
<style lang="scss">
.v-input--radio-group__input {
    label {
        margin: 0 !important;
    }
}
</style>
<script>
import moment from "moment";
import axios from "../../../../src/axios-auth";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Ver from "../EquiposyHerramientas/Remito.vue";

export default {
    components: { Ver },
    data: (vm) => ({
        showVer: false,
        editedItem: {},
        editedIndex: -1,
        deshabilitar: false,
        botonimprimir: true,
        botonenviar: true,
        lazy: false,
        fecha: moment().format("DD/MM/YYYY"),
        anio: moment().format("YYYY"),
        mes: moment().subtract(1, 'months').format("MM"),
        deposito: "",
        detalledeposito: "",
        tipo: "T",
        listadomeses: [
            { detalle: "ENERO", codigo: "01" },
            { detalle: "FEBRERO", codigo: "02" },
            { detalle: "MARZO", codigo: "03" },
            { detalle: "ABRIL", codigo: "04" },
            { detalle: "MAYO", codigo: "05" },
            { detalle: "JUNIO", codigo: "06" },
            { detalle: "JULIO", codigo: "07" },
            { detalle: "AGOSTO", codigo: "08" },
            { detalle: "SEPTIEMBRE", codigo: "09" },
            { detalle: "OCTUBRE", codigo: "10" },
            { detalle: "NOVIEMBRE", codigo: "11" },
            { detalle: "DICIEMBRE", codigo: "12" },
        ],
        valid: false,
        listadoimprimir: [],
        bienesalquilados: [],
        bienesalquiladosdeposito: [],
        cobro: [],
        total: 0,
        totalD: 0,
        headers: [
            { text: "Código", value: "codigo", width: "10%", sortable: false },
            { text: "Depósito", value: "detalle", width: "60%", sortable: false },
            { text: "Total", value: "total", width: "20%", sortable: false },
            { text: "Ver", value: "actions", width: "10%", sortable: false },
        ],
        headersC: [
            { text: "Código", value: "codgral", width: "10%", sortable: false },
            { text: "Bien", value: "detalle", width: "30%", sortable: false },
            { text: "Fecha Alquiler", value: "fechaalq", width: "10%", sortable: false },
            { text: "Fecha Devolucion", value: "fechadev", width: "10%", sortable: false },
            { text: "Remito", value: "remito", width: "10%", sortable: false },
            { text: "Estado", value: "estado", width: "10%", sortable: false },
            { text: "Días", value: "dias", width: "10%", sortable: false },
            { text: "Total", value: "total", width: "10%", sortable: false },
        ]
    }),

    computed: {

        show: {
            get() {
                this.cargarDepositos();
            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    this.$refs.form.resetValidation();
                    document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                    this.$emit("close");
                }
            },
        },
    },

    methods: {

        cargarDepositos() {
            let self = this;
            axios
                .get("/SSGG/CargarDepositos?", {
                    params: {
                        filtrocodigo: "",
                        filtrodetalle: "",
                        filtroestado: "",
                    },
                })
                .then((response) => {
                    self.listadodeposito = response.data;
                })
                .catch((error) => {
                    self.listadodeposito = "";
                    console.log(error);
                });
        },

        ver(item) {
            this.editedIndex = this.listadodeposito.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showVer = true;
        },

        cargarAlquiler() {

            var total = 0;
            if (this.tipo == "T") {
                this.deposito = "TODOS"
                if (this.mes != "" && this.mes != null && this.anio != "" && this.anio != null) {
                    this.botonimprimir = false
                    this.botonenviar = false
                }
            }
            let self = this;
            // console.log("DEPOSITO" + self.deposito)

            axios
                .get("/SSGG/CargarCobroAlquiler?", {
                    params: {
                        mes: self.mes,
                        anio: self.anio,
                        deposito: self.deposito,
                    },
                })
                .then((response) => {
                    self.bienesalquilados = response.data;
                    response.data.forEach(element => {
                        total = total + parseFloat(element.total);
                    });
                    self.total = total.toFixed(2);
                })
                .catch((error) => {
                    self.bienesalquilados = [];
                    console.log("ERROR" + error);
                });
        },
        async imprimirAlquiler() {
            await this.llenarCampos()
            var vm = this;
            var columns = [
                { title: "Cód.", dataKey: "codgral" },
                { title: "Bien", dataKey: "detalle" },
                { title: "Fecha Alquiler", dataKey: "fechaalq" },
                { title: "Fecha Devolución", dataKey: "fechadev" },
                { title: "Remito", dataKey: "remito" },
                { title: "Días", dataKey: "dias" },
                { title: "Total", dataKey: "total" },
            ];

            var doc = new jsPDF();
            doc.setLineWidth(0.5);
            doc.line(10, 11, 200, 11);
            doc.line(10, 11, 10, 41);
            doc.line(40, 26, 200, 26);
            doc.addImage(
                "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",
                "JPEG",
                15,
                15,
                22,
                22
            );
            doc.setFontSize(12);
            doc.text("INFORME DE BIENES ALQUILADOS A COBRAR", 45, 20);
            doc.setFontSize(10);
            doc.text("Año: " + vm.anio, 170, 18);
            doc.text("Mes: " + vm.mes, 170, 23);
            doc.text("Fecha: " + vm.fecha, 167, 35);
            doc.line(40, 11, 40, 41);
            doc.line(165, 11, 165, 41);
            doc.line(10, 41, 200, 41);
            doc.line(200, 11, 200, 41);
            doc.setFontSize(10);

            doc.setFontSize(11);

            var final = 50; // Posición vertical inicial
            var i = 0;
            vm.listadoimprimir.forEach(element => {
                // Agrega el título
                doc.setFontSize(12); // Tamaño de fuente del título
                doc.text(element.title, 15, final);
                final += 5; // Incrementa la posición vertical para dejar espacio entre el título y la tabla

                // Genera la tabla
                const data = element.value;
                const title = element.title;
                doc.autoTable(columns, data, {
                    startY: final, // Posición vertical inicial de la tabla
                    theme: 'grid',
                    foot: [['TOTAL', '', '', '', '', '', '$ ' + element.total]],
                    margin: { top: 10 },
                    columnStyles: {
                        0: { cellWidth: 15 }, // Ancho de la primera columna
                        1: { cellWidth: 50 }, // Ancho de la segunda columna
                        2: { cellWidth: 25 }, // Ancho de la tercera columna
                        3: { cellWidth: 25 }, // Ancho de la cuarta columna
                        4: { cellWidth: 20 }, // Ancho de la quinta columna
                        5: { cellWidth: 15 }, // Ancho de la sexta columna
                        6: { cellWidth: 35 } // Ancho de la séptima columna
                    },
                    styles: { fontSize: 10 },

                });

                // Actualiza la posición final para la próxima iteración
                final = doc.lastAutoTable.finalY + 10; // Añade 10 para espacio entre tablas

                // Verifica si es necesario agregar una nueva página
                if (final >= 250) {
                    doc.addPage();
                    final = 10; // Resetea la posición vertical
                }
            });

            doc.output('dataurlnewwindow');

            // doc.save("Alquileres" + vm.mes + vm.anio + ".pdf");

        },
        async llenarCampos() {
            return new Promise(async (resolve, reject) => {
                try {
                    for (const element of this.bienesalquilados) {
                        await this.cargarAlquilerDeposito(element.codigo, element.detalle, '2');
                    }
                    resolve();
                } catch (error) {
                    reject(error);
                }
            });
        },
        async cargarAlquilerDeposito(filtro, deposito, flag) {
            var totalD = 0;
            const response = await axios
                .get("/SSGG/CargarCobroAlquilerDeposito?", {
                    params: {
                        mes: this.mes,
                        anio: this.anio,
                        deposito: filtro,
                    },
                })
            if (flag == '1') {
                this.detalledeposito = filtro + '-' + deposito
                this.bienesalquiladosdeposito = response.data;
                response.data.forEach(element => {
                    totalD = totalD + parseFloat(element.total);
                });

                this.totalD = totalD.toFixed(2);

            }
            if (flag == '2') {
                totalD = 0;
                this.bienesalquiladosdeposito = [];
                response.data.forEach(element => {
                    totalD = totalD + parseFloat(element.total);
                });
                this.listadoimprimir.push({ title: filtro + '-' + deposito, value: response.data, total: totalD });
            }

        },

        enviarAviso() {
            this.botonenviar = true;
            this.bienesalquilados.forEach((element) => {
                if (element.codigo != "" && element.codigo != null) {
                    this.cobro.push({
                        mes: this.mes,
                        anio: this.anio,
                        codigo: element.codigo,
                        detalle: element.detalle,
                        total: element.total,

                    })
                }
            })
            let self = this;

            axios
                .post("/SSGG/GuardarCobroAlq", this.cobro)
                .then((response) => {
                    self.$refs.form.resetValidation();
                    self.vaciarModels();
                    self.showAlert({
                        icon: "success",
                        title: "Aviso enviado con éxito",
                        vm: self,
                    });
                    self.$emit("close");
                })
                .catch({});
        },

        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 2000,
            });
        },
        vaciarModels() {
            this.bienesalquilados = []
            this.total = 0
        }
    },
};
</script>